import { useMemo } from 'react';

/*

The useConst hook is like a constant in a component.
It runs the init state getter only once and remembers the value.

  const random = useConst(() => `random-${ Math.random() }`);

*/

export const useConst = <T>(initialStateGetter: () => T) => {
  return useMemo(initialStateGetter, []);
};
